import React, { useState } from "react";
import {
  Grid,
  Paper,
  TextField,
  Button,
  Typography,
  FormControl,
  CircularProgress,
  Link as MuiLink,
} from "@mui/material";
import { observer } from "mobx-react";
import { useRootStore } from "../../store/contexts";
import { Link } from "react-router";
import { API_URL } from "../../api/apiClient";

export const ForgotPasswordForm = observer(() => {
  const rootStore = useRootStore();
  const lang = rootStore.langStore;

  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState("");

  const paperStyle = {
    padding: 20,
    height: "auto",
    minHeight: "320px",
    width: 300,
    margin: "20px auto",
  };
  const logoStyle = {
    maxWidth: "80%",
    height: "auto",
    objectFit: "contain" as const,
    marginTop: 8,
    marginBottom: 8,
  };

  const handleSubmit = async () => {
    if (!email || !email.includes("@")) {
      setError(lang.badSyntaxEmail || "Invalid email format");
      return;
    }

    setLoading(true);
    setError("");

    try {
      const response = await fetch(`${API_URL}/api/auth/forgot-password`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email }),
      });

      if (response.ok) {
        setSubmitted(true);
      } else {
        setError(lang.serverError || "Server error");
      }
    } catch (err) {
      setError(lang.serverError || "Server error");
    } finally {
      setLoading(false);
    }
  };

  const handleKeyPress = (event: React.KeyboardEvent) => {
    if (event.key === "Enter" && !loading) {
      handleSubmit();
    }
  };

  if (submitted) {
    return (
      <Grid>
        <Paper elevation={10} style={paperStyle}>
          <Grid container direction="column" alignItems="center">
            <img src="/logo1.png" alt="Logo" style={logoStyle} />
            <h2>{lang.forgotPasswordTitle}</h2>
          </Grid>
          <Typography style={{ marginTop: 20, textAlign: "center" }}>
            {lang.forgotPasswordEmailSent}
          </Typography>
          <MuiLink
            component={Link}
            to="/login"
            style={{ display: "block", marginTop: 20, textAlign: "center" }}
          >
            {lang.backToLoginLabel}
          </MuiLink>
        </Paper>
      </Grid>
    );
  }

  return (
    <Grid>
      <Paper elevation={10} style={paperStyle}>
        <Grid container direction="column" alignItems="center">
          <img src="/logo1.png" alt="Logo" style={logoStyle} />
          <h2>{lang.forgotPasswordTitle}</h2>
        </Grid>
        <FormControl fullWidth>
          <Typography style={{ marginBottom: 16, textAlign: "center" }}>
            {lang.forgotPasswordInstructions}
          </Typography>
          <TextField
            autoComplete="email"
            type="email"
            name="email"
            id="email"
            sx={{ m: 1 }}
            label="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            onKeyPress={handleKeyPress}
            placeholder="Enter email"
            fullWidth
            required
            disabled={loading}
          />
          <Button
            type="submit"
            color="primary"
            variant="contained"
            sx={{ m: 1 }}
            fullWidth
            onClick={handleSubmit}
            disabled={loading}
          >
            {loading ? <CircularProgress size={24} /> : lang.sendResetLinkLabel}
          </Button>
          {error && (
            <Typography color="error" sx={{ m: 1 }}>
              {error}
            </Typography>
          )}
          <MuiLink
            component={Link}
            to="/login"
            style={{ display: "block", marginTop: 16, textAlign: "center" }}
          >
            {lang.backToLoginLabel}
          </MuiLink>
        </FormControl>
      </Paper>
    </Grid>
  );
});
